<script>
export default {
    name: 'Illu50cent',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-0cent"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle :stroke="secondaryColor" class="secondary-color" cx="32" cy="32" r="23.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="32" cy="32" r="19.5" />
            <path
                d="M20.752 37c.97 0 1.78-.157 2.433-.471.652-.315 1.135-.724 1.448-1.23a3.095 3.095 0 00.468-1.66c0-.91-.314-1.646-.944-2.206-.63-.56-1.611-.84-2.943-.84h-.49l.068-.943h3.684V27.22h-6.32l-.476 5.806h2.76c.543 0 .919.057 1.127.17a.55.55 0 01.313.513c0 .236-.116.42-.347.553-.23.132-.532.198-.904.198-.416 0-.845-.06-1.284-.178a5.313 5.313 0 01-1.258-.519L17 36.14c.498.283 1.08.497 1.747.642a9.356 9.356 0 002.005.219zm9.297 0c.843 0 1.589-.198 2.236-.594.648-.396 1.156-.97 1.523-1.722.367-.75.55-1.646.55-2.684 0-1.038-.183-1.933-.55-2.684-.367-.752-.875-1.326-1.523-1.722-.647-.396-1.393-.594-2.236-.594-.842 0-1.588.198-2.236.594-.648.396-1.155.97-1.522 1.722-.367.75-.55 1.646-.55 2.684 0 1.038.183 1.933.55 2.684.367.752.874 1.326 1.522 1.722.648.396 1.394.594 2.236.594zm0-2.582c-.725 0-1.087-.806-1.087-2.418s.362-2.418 1.087-2.418 1.088.806 1.088 2.418-.363 2.418-1.088 2.418zm7.45-2.008c.743 0 1.35-.237 1.82-.71.472-.474.708-1.125.708-1.954 0-.556-.109-1.034-.327-1.435a2.222 2.222 0 00-.903-.915 2.672 2.672 0 00-1.299-.314c-.48 0-.913.105-1.298.314-.385.21-.686.515-.904.915-.217.401-.326.88-.326 1.435 0 .829.236 1.48.707 1.953.471.474 1.078.71 1.821.71zm1.386 4.371l6.497-9.562h-2.297l-6.497 9.562h2.297zm-1.387-5.847c-.172 0-.314-.093-.428-.28-.113-.186-.17-.49-.17-.908 0-.419.057-.722.17-.909.114-.186.256-.28.428-.28.173 0 .315.094.429.28.113.187.17.49.17.909 0 .419-.057.722-.17.908-.114.187-.256.28-.429.28zm6.974 5.984c.743 0 1.35-.237 1.821-.71.471-.474.707-1.125.707-1.954 0-.555-.109-1.034-.326-1.434a2.222 2.222 0 00-.904-.916 2.672 2.672 0 00-1.298-.314c-.48 0-.913.105-1.298.314-.386.21-.687.515-.904.916-.218.4-.327.879-.327 1.434 0 .829.236 1.48.707 1.954.471.473 1.079.71 1.822.71zm0-1.475c-.172 0-.315-.094-.429-.28-.113-.187-.17-.49-.17-.909 0-.419.057-.722.17-.908.114-.187.257-.28.429-.28s.315.093.428.28c.113.186.17.49.17.908 0 .419-.057.722-.17.909-.113.186-.256.28-.428.28z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
